module.exports = __webpack_public_path__ + "static/media/pic_19.22125db5.jpg";